//src/components/UI/Card.jsx

import React from "react";

export default function Card({
  children,
  className = "",
  hoverable = false,
  onClick,
}) {
  return (
    <div
      onClick={onClick}
      className={`
        rounded-2xl border border-gray-200 bg-white p-5 shadow-sm
        transition-all duration-200

        ${hoverable ? "hover:shadow-md hover:border-gray-300 hover:-translate-y-0.5 cursor-pointer" : ""}

        ${className}
      `}
    >
      {children}
    </div>
  );
}
